import { color } from './color';
import { layout } from './layout';
import { margin, padding } from './space';

const fields = [
  {
    name: 'bgColor',
    label: 'Background color',
    component: 'select',
    options: color.options,
    defaultValue: color.value.background,
  },
  {
    name: 'color',
    label: 'Text color',
    component: 'select',
    options: color.options,
    defaultValue: color.value.text,
  },
];

const mobileFields = [
  {
    label: 'Container width (mobile)',
    component: 'select',
    name: 'container',
    options: layout.optionsMobile,
  },
  {
    name: 'mt',
    label: 'Margin top (mobile)',
    component: 'select',
    options: margin.options,
  },
  {
    name: 'py',
    label: 'Vertical padding (mobile)',
    component: 'select',
    options: padding.options,
  },
];

const mobileDefaultValue = {
  container: layout.value.container,
  mt: 'none',
  py: 'none',
};

const desktopFields = [
  {
    label: 'Container width (desktop)',
    component: 'select',
    name: 'container',
    options: layout.options,
  },
  {
    name: 'mt',
    label: 'Margin top (desktop)',
    component: 'select',
    options: margin.options,
  },
  {
    name: 'py',
    label: 'Vertical padding (desktop)',
    component: 'select',
    options: padding.options,
  },
];

const desktopDefaultValue = {
  container: layout.value.container,
  mt: 'none',
  py: 'none',
};

const mobile = {
  label: 'Mobile Settings',
  name: 'mobile',
  component: 'group',
  fields: mobileFields,
  defaultValue: mobileDefaultValue,
};

const desktop = {
  label: 'Desktop Settings',
  name: 'desktop',
  component: 'group',
  fields: desktopFields,
  defaultValue: desktopDefaultValue,
};

const mobileWithHeight = {
  label: 'Mobile Settings',
  name: 'mobile',
  component: 'group',
  fields: [
    ...mobileFields,
    {
      name: 'minHeight',
      component: 'number',
      label: 'Min section pixel height (mobile)',
    },
    {
      name: 'maxHeight',
      component: 'number',
      label: 'Max section pixel height (mobile)',
    },
  ],
  defaultValue: {
    ...mobileDefaultValue,
    container: layout.value.padded,
    maxHeight: 375,
    minHeight: 375,
  },
};

const desktopWithHeight = {
  label: 'Desktop Settings',
  name: 'desktop',
  component: 'group',
  fields: [
    ...desktopFields,
    {
      name: 'minHeight',
      component: 'number',
      label: 'Min section pixel height (desktop)',
    },
    {
      name: 'maxHeight',
      component: 'number',
      label: 'Max section pixel height (desktop)',
    },
  ],
  defaultValue: {
    ...desktopDefaultValue,
    container: layout.value.padded,
    maxHeight: 460,
    minHeight: 460,
  },
};

export const section = {
  label: 'Section Settings',
  name: 'section',
  description:
    'Background color, text color, container width, margin top, vertical padding',
  component: 'group',
  fields: [...fields, desktop, mobile],
};

export const sectionWithHeight = {
  label: 'Section Settings',
  name: 'section',
  description:
    'Background color, text color, container width, margin top, vertical padding, section heights',
  component: 'group',
  fields: [...fields, desktopWithHeight, mobileWithHeight],
};
